<template>
  <div id="serve" class="inline-block" style="vertical-align: top">
    <div class="header">
      <div style="display: flex; align-items: center; margin-top: 10px; margin-left: -5px;">
        <el-avatar
          class="available"
          size="large"
          :src="userInfo !== null ? userInfo.avatarUrl : logo"
          style="margin: 0 6px"
          @click.native="toPage('/PC/mine')"
        >
        </el-avatar>
        <span style="color: #888"><el-link  @click="toPage('/PC/mine')" v-if="this.$store.state.userInfo != null">{{this.$store.state.userInfo.nickName}}</el-link></span>
        <span style="color: #888" v-if="this.$store.state.userInfo == null">
          <el-link @click="toPage('/PC/login?isLogin=true')" :underline="false"
          >您好,请登录
          </el-link>
        </span>
      </div>
      <div style="margin-top: 10px">
        <!-- <template v-if="userInfo === null"> -->
        <template v-if="userInfo === null">
          <el-link @click="toPage('/PC/login?isLogin=true')"> 登录 </el-link>
          <span class="div"> | </span>
          <el-link @click="toPage('/PC/login?isLogin=false')">注册</el-link>
        </template>
        <template v-else>
          <el-link :underline="false">{{ sayHello }}(*^▽^*)</el-link>
        </template>
      </div>
      <div style="margin: 4px 0 0">
<!--        <el-button type="danger" round size="small">新人福利</el-button>-->
<!--        <el-button type="warning" round size="small">PLUS会员</el-button>-->
      </div>
    </div>
    <div class="hr" style="margin-top: 10px"></div>
    <div class="news">
      <div class="top">
        <span class="title" style="align-content: center">信 息 公 告</span>
<!--        <el-link class="link" @click="moreAffiche">更多</el-link>-->
      </div>
      <div class="lists" style="margin-top: 20px" v-for="(notice,index) in newAffiche">
        <el-tag type="danger" v-if="index == 0" size="mini">最新</el-tag>
        <span><a href="#" style="font-size: x-small; color: #0a76a4" @click="getArtcle(notice.id)">{{ notice.title }}</a></span></br>
      </div>
    </div>
    <!--更多公告-->
    <el-dialog :title="title" :visible.sync="centerDialogVisible" width="550px" append-to-body>
      <span v-for="item in affiche">
        <p style="font-size: x-large">{{item.title}}</p>
        <p style="font-size: large">时间：{{item.addTime}}</p>
        <p style="font-size: large" v-html="item.content"></p>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">关  闭</el-button>
      </span>
    </el-dialog>
    <!--公告详情-->
    <el-dialog :title="title" :visible.sync="articleDialogVisible" width="1180px"  append-to-body>
      <span style="width: 630px;">
        <p style="font-size: x-large">{{artcleDetail.title}}</p>
        <p style="font-size: large; margin-top: 10px" icon="el-icon-time">{{artcleDetail.updateTime}}</p>
        <div><p style="font-size: large; margin-top: 20px" v-html="artcleDetail.content"></p></div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="articleDialogVisible = false">关  闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import nav from './nav.config';
// import logo from './logo.config';
import { getArtcle } from '@/api/article/article.js'
export default {
  name: 'Serve',
  props: {
    parent: '',
  },
  watch: {
    parent: {
      handler(newVal, oldVal) {
        if (this.affiche != null) {
          this.affiche = newVal;
          this.getList();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      //所有公告信息
      affiche: [],
      //最新公告
      newAffiche: [],
      nav,
      logo: '/static/images/headImg/8.jpg',
      title: '',
      //信息公告
      centerDialogVisible: false,
      //公告详情
      articleDialogVisible: false,
      //公告详情
      artcleDetail: [],
    };
  },
  computed: {
    userInfo() {
      console.log("this.$store.state.userInfo")
      console.log(this.$store.state.userInfo)
      return this.$store.state.userInfo;
    },
    sayHello() {
      let d = new Date();
      let hour = d.getHours();
      if (hour <= 12) {
        return '上午好';
      } else if (hour < 18) {
        return '下午好';
      } else {
        return '晚上好';
      }
    },
  },
  methods: {
    getArtcle(id) {
      this.title = '公告详情'
      this.articleDialogVisible = true
      getArtcle(id).then(response=>{
        this.artcleDetail = response.data
      })
    },
    toPage(item) {
      this.$router.push(item);
    },
    getList() {
      this.affiche = this.parent
      this.newAffiche = this.affiche;
    },
    moreAffiche() {
      this.title = "信息公告";
      this.centerDialogVisible = true;
    }
  },
};
</script>

<style scoped>
#serve {
  width: 150px;
  height: 470px;
  background: #fff;
}

#serve .header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#serve .news {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#serve .news .top .title {
  font-weight: 600;
  position: center;
  left: -26px;
}

#serve .news .top .link {
  position: relative;
  left: 28px;
}

#serve .nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

#serve .nav .item-element {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 56px;
  margin-bottom: 2px;
}
.available {
  cursor: pointer;  /*鼠标悬停变小手*/
}
</style>



// WEBPACK FOOTER //
// src/views/PC/serve/Serve.vue